import React from 'react';

function Strikethrough(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M18.25 2.62305C18.25 2.27787 17.9702 1.99805 17.625 1.99805H11.7725L11.5609 2.00292C9.16848 2.11287 7 4.06989 7 6.37305C7 8.81151 8.14919 10.0951 11.3715 11.998H2.625L2.53264 12.0048C2.23126 12.0495 2 12.3092 2 12.623C2 12.9682 2.27982 13.248 2.625 13.248H13.5335C16.1345 14.8192 17 15.8509 17 17.623C17 19.3487 15.6007 20.748 13.875 20.748H7.625L7.53264 20.7548C7.23126 20.7995 7 21.0592 7 21.373C7 21.7182 7.27982 21.998 7.625 21.998H13.875L14.087 21.993C16.4046 21.8824 18.25 19.968 18.25 17.623C18.25 15.7519 17.5734 14.5608 15.8026 13.248H21.375L21.4674 13.2413C21.7687 13.1966 22 12.9368 22 12.623C22 12.2779 21.7202 11.998 21.375 11.998H13.8784C13.771 11.9346 13.6612 11.8704 13.5491 11.8055L12.6242 11.2794C9.31322 9.3918 8.25 8.33726 8.25 6.37305C8.25 4.73342 9.95314 3.24805 11.7725 3.24805H17.625L17.7174 3.24127C18.0187 3.19663 18.25 2.93685 18.25 2.62305Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Strikethrough;
